<section class="content-layout">
  <bw-action-article-legacy>
    <ui-nav-exit-back
      back-action-top
      [trackingDetail]="{ event_name: 'find_money' }"
    ></ui-nav-exit-back>

    <div content-section>
      <div class="flex-column mb-sm">
        <div class="align-left">
          <p title-medium class="mb-sm">{{ 'FIND_MONEY_TITLE' | translate }}</p>
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="left" style="max-width: 832px">
              {{ 'FIND_MONEY_DESC' | translate }}
            </p>
          </typography-legacy>
          <ng-container *ngIf="partnerCardList$ | async as partnerCardList; else spinner">
            <div class="partner__container mt-md" *ngIf="partnerCardList.length">
              <div class="partner__item" *ngFor="let partnerCardItem of partnerCardList">
                <bw-action-card-legacy [cardConfig]="partnerCardItem" (ctaClicked)="onCtaClicked(partnerCardItem.data)"></bw-action-card-legacy>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </bw-action-article-legacy>
</section>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
